.hoverableImageContainer {
    text-decoration: none;
}

.hoverableImage {
    height: 100%;
    width: 100%;
    object-fit: cover;
    object-position: top;
    transition-property: all;
    transition-duration: 0.33s;
    transition-timing-function: ease-in-out;
}

@media (min-width: 768px) {
    .hoverableImage {
        object-position: 50% 40%;
    }
}

.hoverableImageContainer:hover > .hoverableImage {
    transform: scale(1.075);
}

.imageOverlay {
    background-color: #000000;
    opacity: 0.5;
    transition-property: all;
    transition-duration: 0.33s;
    transition-timing-function: ease-in-out;
}

.hoverableImageContainer:hover > .imageOverlay {
    opacity: 0.35;
}

.hoverableImageText {
    color: #FFFFFF;
    z-index: 2;
    letter-spacing: 0.5px;
    font-size: 26px;
    font-weight: bold;
    text-shadow: 0 0 15px rgba(0, 0, 0, 0.4);
    padding: 180px 20px;
}
